export default __webpack_public_path__ + "b44f70db8aa4ff4f6babc1aac26ff1c9.png";